/**
 * Calculate responsive grid columns based on screen width
 * Used for friends/groups grid layouts
 */
export const calculateColumns = (width: number): number => {
  if (width < 768) return 2 // Mobile
  if (width < 1024) return 3 // Tablet
  if (width < 1440) return 4 // Desktop
  return 5 // Large Desktop
}
